"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
const activeicon = require("@/assets/style/icon/activeIcon.png");
let ColumnOperate = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
    this.activeIcon = activeicon;
    this.skip_check = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.launcher.restart",
        (data) => __async(this, null, function* () {
          if (data.value.new_shop_id === this._column.id) {
            this._column.runtime.status = "loading";
          }
        })
      );
    });
  }
  checkVersion() {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version === "6.8.2.7") {
          let realVersion = version_response.data.os.version.split("(")[0].trim();
          if (realVersion === "0" || realVersion === "7") {
            let response = yield API.get(
              `api://base.auth/api/v9/shop/${this._column.shopOldId}/browser_core`
            );
            if (response.data.code === "chrome" && response.data.version === "122") {
              try {
                try {
                  yield API.get(
                    `api://base.local/storages/session/checkOpenWin7`
                  );
                } catch (error) {
                  yield UiConfirm.warnconfirm(
                    `${this.$t("main.win7_tips_message")}`,
                    this.$t("main.win7_tips_title"),
                    {
                      confirmButtonText: this.$t(
                        "main.win7_tips_confirm"
                      ),
                      customClass: "new-confirm-box",
                      showClose: false,
                      cancelButtonText: this.$t("headertoolbar.cancel")
                    }
                  );
                }
                yield API.put(`api://base.local/storages/session/checkOpenWin7`, {
                  message: "no.show.win7",
                  model: "no.show.win7"
                });
                try {
                  yield API.post(
                    `api://base.auth/api/v9/shop/${this._column.shopOldId}/browser_core_auto_downgrade`
                  );
                } catch (error) {
                  return false;
                }
                return false;
              } catch (error) {
                return true;
              }
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    });
  }
  // @Debounce(800)
  launcher() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      try {
        if (((_a = this._column.vd) == null ? void 0 : _a.marks) && ((_b = this._column.vd) == null ? void 0 : _b.marks.is("FLOW_OVER_RANGE"))) {
          try {
            const response = yield API.get(
              `api://base.local/storages/preference/flow_overrange`
            );
            const date = response.data.value.date;
            const now = new Date().getTime();
            if (now - date > 1e3 * 60 * 60 * 24) {
              try {
                yield UiConfirm.warnconfirm(
                  this.$t("over_flow_dialog.tips"),
                  this.$t("over_flow_dialog.title"),
                  {
                    confirmButtonText: this.$t(
                      "over_flow_dialog.confirm"
                    ),
                    showClose: false,
                    customClass: "new-confirm-box"
                  }
                );
              } catch (error) {
                if (error === "cancel") {
                  return;
                }
              }
            }
          } catch (error) {
            try {
              yield UiConfirm.warnconfirm(
                this.$t("over_flow_dialog.tips"),
                this.$t("over_flow_dialog.title"),
                {
                  confirmButtonText: this.$t(
                    "over_flow_dialog.confirm"
                  ),
                  showClose: false,
                  customClass: "new-confirm-box"
                }
              );
            } catch (error2) {
              if (error2 === "cancel") {
                return;
              }
            }
          }
        }
        const flag = yield this.checkVersion();
        if (flag === true) {
          return;
        }
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version !== "6.8.2.7") {
          const result = yield this.checkHasBrowserCore(this._column);
          console.log(result);
          if (!result.flag) {
            const version = result.version;
            const code = result.code;
            const h = this.$createElement;
            let self = this;
            this.$confirm("", this.$t("main.browser_core_tips_title"), {
              message: h("div", void 0, [
                h(
                  "div",
                  {
                    class: "text-content",
                    style: "overflow: hidden;text-overflow: ellipsis;"
                  },
                  `${this.$t("main.browser_core_tips_message", {
                    version,
                    code
                  })}`
                ),
                h(
                  "el-checkbox",
                  {
                    class: {
                      "ui-checkbox": true
                    },
                    key: Math.random(),
                    domProps: {
                      checked: self.skip_check
                    },
                    on: {
                      input: function(event) {
                        self.skip_check = event;
                      }
                    }
                  },
                  `${this.$t("main.browser_core_tips_message_skip")}`
                )
              ]),
              confirmButtonText: this.$t("main.browser_core_confirm"),
              cancelButtonText: this.$t("vdcontainer.cancel"),
              roundButton: true,
              type: "warning"
            }).then(() => __async(this, null, function* () {
              var _a2, _b2;
              if (this.skip_check) {
                yield API.put(
                  `api://base.local/storages/preference/browser_core_skip_check`,
                  {
                    model: "browser_core_skip_check"
                  }
                );
                this.skip_check = false;
              }
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.download.core",
                value: {
                  shop_id: this._column.shopOldId,
                  vd_id: (_a2 = this._column.vd) == null ? void 0 : _a2.oldId,
                  new_vd: (_b2 = this._column.vd) == null ? void 0 : _b2.id,
                  new_shop_id: this._column.id,
                  code,
                  version
                }
              });
            })).catch((error) => {
              this.skip_check = false;
              return;
            });
            return;
          }
        }
        this._column.runtime.status = "loading";
        try {
          yield API.get(
            `api://base.local/storages/preference/mainExtensionVersion`
          );
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher_new",
            value: {
              shop_id: this._column.shopOldId,
              vd_id: (_c = this._column.vd) == null ? void 0 : _c.oldId,
              new_vd: (_d = this._column.vd) == null ? void 0 : _d.id,
              new_shop_id: this._column.id
            }
          });
        } catch (error) {
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.launcher",
            value: {
              shop_id: this._column.shopOldId,
              vd_id: (_e = this._column.vd) == null ? void 0 : _e.oldId,
              new_vd: (_f = this._column.vd) == null ? void 0 : _f.id,
              new_shop_id: this._column.id
            }
          });
        }
      } catch (error) {
      }
    });
  }
  checkNewVersion(version, target) {
    const v1 = version.split(".").map(Number);
    const v2 = target.split(".").map(Number);
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1 = v1[i] || 0;
      const num2 = v2[i] || 0;
      if (num1 > num2)
        return true;
      if (num1 < num2)
        return false;
    }
    return false;
  }
  checkHasBrowserCore(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.local/storages/preference/mainExtensionVersion`
        );
        let _version = response.data.value.version;
        console.log(_version);
        const flag = this.checkNewVersion("8.8.4", _version);
        console.log(flag);
        if (flag) {
          return {
            flag: true
          };
        }
      } catch (error) {
        return {
          flag: true
        };
      }
      try {
        yield API.get(
          `api://base.local/storages/preference/browser_core_skip_check`
        );
        return {
          flag: true
        };
      } catch (error) {
      }
      try {
        const response = yield API.get(
          `api://base.auth/api/v9/shop/${item.shopOldId}/browser_core`
        );
        try {
          yield API.get(
            `api://base.local/v2/dynamic-browsers/brands/${response.data.code}/versions/${response.data.version}`
          );
          return {
            flag: true
          };
        } catch (error) {
          return {
            flag: false,
            version: response.data.version,
            code: response.data.code
          };
        }
      } catch (error) {
        return {
          flag: true
        };
      }
    });
  }
  onActive() {
    return __async(this, null, function* () {
      try {
        yield API.put(
          `api://base.local/v2/dynamic-browsers/${this._column.shopOldId}`
        );
      } catch (error) {
      }
    });
  }
  closeShop() {
    return __async(this, null, function* () {
      try {
        yield API.delete(
          `api://base.local/v2/dynamic-browsers/${this._column.shopOldId}`
        );
        this._column.runtime.status = "ready";
      } catch (error) {
        this._column.runtime.status = "ready";
      }
    });
  }
  toBindVD() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
      }
    });
  }
  toRenew() {
    return __async(this, null, function* () {
      var _a, _b;
      if (!((_a = this.$session) == null ? void 0 : _a.permissions.is("VD_RENEW"))) {
        this.$message.error(
          this.$i18n.t("main.not_have_renew_permission")
        );
        return;
      }
      let response = yield API.get(
        `api://base.auth.pro/v1/virtual-desktops/${(_b = this._column.vd) == null ? void 0 : _b.id}`
      );
      this.$router.push({
        name: "payment",
        query: {
          style: "renew"
        },
        params: {
          item: JSON.stringify(response.data)
        }
      });
    });
  }
  toBuy() {
    return __async(this, null, function* () {
      let shop_id = this._column.shopOldId;
      let flag = "false";
      if (this._column.marks.is("DELETE")) {
        flag = "true";
      }
      this.$router.push({
        name: "payment",
        query: { style: "create" },
        params: {
          shop_id,
          is_delete: flag
        }
      });
    });
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "shop-detail":
          this.$emit("shopDetail", this._column);
          break;
        case "edit-shop":
          this.$emit("editShop", this._column);
          break;
        case "bind-ip":
          this.$emit("bindIP", this._column);
          break;
        case "choose-admin":
          this.$emit("chooseAdmin", this._column);
          break;
        case "delete-cache":
          this.$emit("deleteCache", this._column);
          break;
        case "add-additional-access":
          this.$emit("additionalAccess", this._column);
          break;
        case "stick-to-top":
          this.$emit("stickToTop", this._column);
          break;
        case "unstick-to-top":
          this.$emit("unstickToTop", this._column);
          break;
        case "edit-group":
          this.$emit("editGroup", this._column);
          break;
        case "delete-shop":
          this.$emit("deleteShop", this._column);
          break;
        case "real-delete-shop":
          this.$emit("realDeleteShop", this._column);
          break;
        case "change-code":
          this.$emit("changeCode", this._column);
          break;
        case "add-video":
          this.$emit("addVideo", this._column);
          break;
        case "close-video":
          this.$emit("closeVideo", this._column);
          break;
        case "import-cookies":
          this.$emit("importCookies", this._column);
          break;
        case "edit-remark":
          this.$emit("editRemark", this._column);
          break;
        case "bind-ip-delete":
          this.$emit("bindIPDelete", this._column);
          break;
        case "cookie-editor":
          this.$emit("cookieEditor", this._column);
          break;
        case "privacy-mode":
          this.$emit("privacyMode", this._column);
          break;
        case "edit-sort":
          this.$emit("editSortNumber", this._column);
          break;
        case "shop-lock":
          this.$emit("setShopLockStatus", this._column);
          break;
        case "shop-unlock":
          this.$emit("setShopUnLockStatus", this._column);
          break;
      }
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnOperate.prototype, "_column", 2);
ColumnOperate = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], ColumnOperate);
export {
  ColumnOperate as default
};
